
export class UserPrivateProductModel {
  constructor() {

  }

  async read(_idcod) {
    return await new Promise((resolve, reject) => {
      APICRUD['producto'].Read(_idcod || '')
        .then(resolve)
        .catch(error => {
          console.log(error);
          reject({});
        });
    });
  }

  async readHide() {
    return await new Promise((resolve, reject) => {
      APICRUD['producto'].ReadHide()
        .then(resolve)
        .catch(error => {
          console.log(error);
          reject({});
        });
    });
  }

  async save(_data, _func) {
    return new Promise((resolve, reject) => {
      APICRUD['producto'][_func](_data)
        .then(_result => {
          if (_result.message == 'OK') {
            APICRUD.ClearCache('W3i8cCUg9uNs8Kq3W85Ru9fP1cP16D');
            resolve();
          } else {
            reject(_result.message);
          }
        })
        .catch(_error => {
          if (_error && _error != 'KO') {
            reject(_error);
          } else {
            reject('Ocurrió un error al intentar guardar su producto, por favor revise su información e inténtelo nuevamente.');
          }
        });

    })
  }

  async delete(_idcod) {
    return new Promise((resolve, reject) => {
      APICRUD['producto'].Delete(_idcod)
        .then(_result => {
          if (_result.message == 'OK') {
            APICRUD.ClearCache('W3i8cCUg9uNs8Kq3W85Ru9fP1cP16D');
            resolve();
          } else {
            reject(_result.message);
          }
        })
        .catch(_error => {
          if (_error && _error != 'KO') {
            reject(_error);
          } else {
            reject('Ocurrió un error al intentar guardar su producto, por favor revise su información e inténtelo nuevamente.');
          }
        });

    })
  }

}
